import { render, staticRenderFns } from "./Ncm.vue?vue&type=template&id=d010f398&scoped=true&"
import script from "./Ncm.vue?vue&type=script&lang=js&"
export * from "./Ncm.vue?vue&type=script&lang=js&"
import style0 from "./Ncm.vue?vue&type=style&index=0&id=d010f398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d010f398",
  null
  
)

export default component.exports